import axios from "axios";
import LocalStorageService from "./local-storage-service";
import { toast } from "react-toastify";
import { getAccountsUrl } from "./accountsUrl";
import queryString from "query-string";

const localStorageService = LocalStorageService.getService();

// For GET requests
const customaxios = axios.create({});
customaxios.interceptors.request.use(
  (config) => {
    if (!!localStorageService.getAccessToken()) {
      const token = localStorageService.getAccessToken();
      if (token) {
        config.headers["ssoToken"] = token;
      }
    }
    if (!!localStorageService.getSessionID()) {
      const session_id = localStorageService.getSessionID();
      config.headers["sessionId"] = session_id;
    }

    config.headers["Content-Type"] = "application/json";
    config.headers["source"] = "gtc";

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//For POST requests
customaxios.interceptors.response.use(
  (res) => {
    // Add configurations here
    res.headers["Content-Type"] = "application/json";
    if (res.status === 201) {
    }
    return res;
  },
  (error) => {
    if (!!error && !!error.response && error.response.status === 401 && window.location.pathname !== "/lcc-embed" && window.location.pathname !== "/classifier-embed") {
      const emailParams = window.location.search;
      toast.error(error?.response?.data?.message);
      setTimeout(() => {
        localStorageService.clearCompleteStorage();
        window.location =
          !!emailParams && emailParams !== "" ? getAccountsUrl() + "?&authentication=false&" + emailParams.replace("?", "") : getAccountsUrl() + "?&authentication=false";
        return Promise.reject(error);
      }, 5000);
    }
    return Promise.reject(error);
  }
);

export default customaxios;

export const getAuthHeaders = (getFromParams) => {
  if (getFromParams) {
    const params = queryString.parse(window.location.search);

    const headers = {
      ...customaxios.defaults.headers.common,
      sessionId: params.sessionId || "",
    };
    return {
      headers,
    };
  }
  return {};
};
